import PropTypes from 'prop-types'

import { formatMoney } from 'utils'

import Text from 'components/Text'

import { Meta, MetaItem, Root } from './CustomerProfile.style'

const CustomerProfile = ({ customer, children }) => {
  return (
    <Root>
      <Meta>
        <Text font="proxima" size="xl" weight="semibold">
          {/* Welcome back, {customer?.firstName} */}
          Your account
        </Text>
        <MetaItem>
          <Text font="proxima" tracking="wide" transform="uppercase" size="sm">
            First name
          </Text>
          <Text>{customer?.firstName || 'N/A'}</Text>
        </MetaItem>
        <MetaItem>
          <Text font="proxima" tracking="wide" transform="uppercase" size="sm">
            Last name
          </Text>
          <Text>{customer?.lastName || 'N/A'}</Text>
        </MetaItem>
        <MetaItem>
          <Text font="proxima" tracking="wide" transform="uppercase" size="sm">
            Phone number
          </Text>
          <Text>{customer?.phone || 'N/A'}</Text>
        </MetaItem>
        <MetaItem>
          <Text font="proxima" tracking="wide" transform="uppercase" size="sm">
            Email address
          </Text>
          <Text>{customer?.email || 'N/A'}</Text>
        </MetaItem>
        <MetaItem>
          <Text font="proxima" tracking="wide" transform="uppercase" size="sm">
            Store credit
          </Text>
          <Text>{formatMoney(customer?.totalCredit || 0 * 100, { fractional: true })}</Text>
        </MetaItem>
      </Meta>
      {children}
    </Root>
  )
}

CustomerProfile.propTypes = {
  customer: PropTypes.object,
}

CustomerProfile.defaultProps = {}

export default CustomerProfile
